// extracted by mini-css-extract-plugin
export var arrowIcon = "lcTOC-module--arrowIcon--f1cf2";
export var tocContainer = "lcTOC-module--tocContainer--bd326";
export var tocItem = "lcTOC-module--tocItem--c4367";
export var tocLink = "lcTOC-module--tocLink--38287";
export var tocNav = "lcTOC-module--tocNav--5bae7";
export var tocNavVisible = "lcTOC-module--tocNavVisible--88d54";
export var tocOpen = "lcTOC-module--tocOpen--d6b36";
export var tocTitle = "lcTOC-module--tocTitle--127c1";
export var tocToggle = "lcTOC-module--tocToggle--d6152";
export var tocWrapper = "lcTOC-module--tocWrapper--a5c5b";